import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';

import { ItemMarcaRoutingModule } from './item-marca-routing.module';
import { ItemMarcaComponent } from './item-marca.component';
import { ItemMarcaFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        ItemMarcaRoutingModule
    ],
    declarations: [
        ItemMarcaComponent,
        ItemMarcaFormComponent
    ]
})
export class ItemMarcaModule { }
